import { catchError } from 'rxjs/operators';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbstractHttpService } from './http-abstract.service';
import { ConfigDto, DynamicField, DynamicLink, SelfRegCardDto, ServiceSelectionDto } from './dtos';
import { Injectable } from '@angular/core';
import { DateNP } from 'datenp';

@Injectable({providedIn: 'root'})
export class HttpSelfRegCardService extends AbstractHttpService {
	constructor(http: HttpClient) {
        super(http);
    }

	private getUri(axonId: number, pin: string): string {
		return `/card/${axonId}/${pin}`;
	}

    getSelfRegCardData(axonId: number, pin: string): Observable<SelfRegCardDto> {
        return super.get(this.getUri(axonId, pin) + "/get");
    }
}